import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import api, { NameValueItem, ProductDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";
import { arrayNotEmpty } from "../../utils";

export interface ProductsGridProps {
  vendorId?: string;
  onRowsSelected?: (rows: ProductDto[]) => void;
}

const formatTokens = (tokens?: NameValueItem[]) : string => {
  if (tokens && arrayNotEmpty(tokens)) {
    return tokens.map(token => `${token.name}=${token.value}`).join(";");
  }
  return "";
}

const columns: GridColDef<ProductDto>[] = [
  { field: "sku", headerName: "SKU", minWidth: 100, flex: 200, editable: false, sortable: true, filterable: false },
  { field: "quantity", headerName: "Quantity", width: 100, editable: false, sortable: true, filterable: false, align: "center" },
  { field: "isDiscontinued", headerName: "Discontinued", width: 100, editable: false, sortable: true, filterable: false, align: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
  { field: "tokens", headerName: "Tokens", minWidth: 200, flex: 400, editable: false, sortable: false, filterable: false, valueGetter: (p) => formatTokens(p.row.tokens) },
  { field: "createdAt", headerName: "Created", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
];

export const ProductsGrid = (props: ProductsGridProps) => {
  const { vendorId, onRowsSelected } = props;

  const loadData = async (page: number, size: number, sort: string, filter: string): Promise<PaginationData<ProductDto>> => {
    if (vendorId) {
      return await api.product.find({ page, size, sort, vendorId, sku: filter } as any);
    }
    return { data: [], count: 0 } as any;
  };

  return <PaginatedDataGrid loadData={loadData} columns={columns} onRowsSelected={onRowsSelected} showFilter checkboxSelection />;
};
